import React, { useEffect, useRef } from 'react';
import { scaleThreshold } from 'd3-scale';
import { axisBottom } from 'd3-axis';
import { select } from 'd3-selection';
import './ChartMapLegend.scss';

const ChartMapLegend = ({ colorConfig, colors, width }) => {
  const {domainLegend: domain, rangeQuantile, steps, usedUnit: unit} = colorConfig;
  const legendWidth = width || 290;
  const createLegend = (container) => {
    const svgLegendWidth = legendWidth;
    const svgLegendHeight = 24;
    const threshold = scaleThreshold().domain(domain).range(rangeQuantile);

    const tickvalues = threshold.domain();
    tickvalues[0] = '';
    tickvalues[tickvalues.length - 1] = '';

    const x = scaleThreshold()
      .domain(tickvalues)
      .range([0, Math.round(svgLegendWidth / steps)]);
    const xAxis = axisBottom(x)
      .tickValues(tickvalues)
      .tickFormat((d) => d)
      .tickSize(10)
      .tickSizeOuter(0);

    // *** rebuild Legend SVG *** //
    const svgEl = select(container);

    const attrViewBox = `0 0 ${svgLegendWidth} ${svgLegendHeight}`;
    const legendTextSelection = svgEl.select('text');
    const legendGroupSelection = svgEl.select('g');

    if (attrViewBox !== svgEl.attr('viewBox')) {
      svgEl.attr('viewBox', attrViewBox).style('overflow', 'visible');
    }

    if (!legendTextSelection.empty()) {
      legendTextSelection.remove();
    }
    if (!legendGroupSelection.empty()) {
      legendGroupSelection.remove();
    }


    svgEl
      .append('text')
      .attr('transform', `translate(${svgLegendWidth - 25}, -17)`)
      .attr('dy', '.75em')
      .attr('fill', colors.themeBase.text)
      .attr('class', 'legend-unit')
      .style('text-anchor', 'end')
      .style('font-size', '14px')
      .text(unit);

    const g = svgEl.append('g').attr('width', '20px').call(xAxis);


    g.select('.domain').remove();

    g.selectAll('rect')
      .data(
        threshold.range().map((color) => {
          const d = threshold.invertExtent(color);
          return [d, color];
        })
      )
      .enter()
      .insert('rect', '.tick')
      .attr('height', 8)
      .attr('x', (d, i) => Math.round(svgLegendWidth / steps) * i)
      .attr('width', Math.round(svgLegendWidth / steps))
      .attr('fill', (d) => d[1]);


    const tickFontSize = colorConfig.unit === '%' ? '8px' : '9px';
    g.selectAll('g').each((d, i, nodes) => {
      select(nodes[i])
        .attr(
          'transform',
          `translate(${Math.round(svgLegendWidth / steps) * i}, 0)`
        )
        .style('font-size', tickFontSize)
        .attr('class', `tick tick-${i}`);
    });

    g.selectAll('g text').text((attrValue) =>
      `${attrValue}`.replace(/\./g, ',')
    );
    // remove first and last tick line
    g.selectAll('.tick-0').attr('opacity', 0);
    g.selectAll('.tick:last-child').attr('opacity', 0);
  };

  const container = useRef(null);

  useEffect(() => {
    createLegend(container.current);
  }, [createLegend]);

  return (
    <div className="legend-wrapper">
      <svg ref={container} className="legend" />
    </div>
  );
};

export default ChartMapLegend;
